<template>
  <aside class="tp-side">
    <div class="card">
      <div class="card-h">题材传播摘要</div>
      <ul class="kv">
        <li v-for="(row, i) in summary" :key="i">
          <span class="k">{{ row.k }}</span>
          <span class="v">{{ row.v }}</span>
        </li>
      </ul>
    </div>

    <div class="card">
      <div class="card-h">趋势条件监控</div>
      <ul class="trends">
        <li v-for="(t, i) in trends" :key="i">
          <span class="mark" :class="{ ok: t.ok }">{{ t.ok ? '✓' : '·' }}</span>
          <span class="label">{{ t.label }}</span>
          <span v-if="t.value" class="val" :class="{ hot: t.ok }">{{ t.value }}</span>
        </li>
      </ul>
    </div>

    <div class="card">
      <div class="card-h">传播提醒</div>
      <ul class="alerts">
        <li v-for="(a, i) in alerts" :key="i">
          <span class="time">{{ a.time }}</span>
          <span class="text">{{ a.text }}</span>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ThemePropSide',
  props: {
    side: { type: Object, default: () => ({}) }
  },
  computed: {
    summary() {
      return (this.side && this.side.summary) || []
    },
    trends() {
      return (this.side && this.side.trends) || []
    },
    alerts() {
      return (this.side && this.side.alerts) || []
    }
  }
}
</script>

<style scoped lang="scss">
.tp-side {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow: auto;
}
.card {
  background: #fff;
  border: 1px solid #d7e4f6;
  border-radius: 12px;
  padding: 10px 12px;
}
.card-h {
  font-size: 13px;
  font-weight: 800;
  margin-bottom: 8px;
  color: #1f2d3d;
}
.kv, .trends, .alerts {
  list-style: none;
  margin: 0;
  padding: 0;
}
.kv li {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding: 5px 0;
  border-bottom: 1px solid #f0f4fa;
  font-size: 12px;
  .k { color: #8aa0c2; }
  .v { color: #1f2d3d; font-weight: 650; }
}
.trends li {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 0;
  font-size: 12px;
}
.mark {
  width: 16px;
  color: #c0c4cc;
  font-weight: 800;
  &.ok { color: #67c23a; }
}
.label { flex: 1; color: #5b6b82; }
.val {
  font-weight: 800;
  &.hot { color: #f56c6c; }
}
.alerts li {
  display: grid;
  grid-template-columns: 42px 1fr;
  gap: 6px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f4fa;
  font-size: 12px;
}
.time { color: #8aa0c2; }
.text { color: #1f2d3d; line-height: 1.35; }
</style>
